import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import IconStatusCheckDisabled from '../../assets/icons/IconStatusCheckDisabled';

import MENU_USER from '../../constants/menuUserConstant';
import RadioTab from '../Radio/RadioTab';
import MasterDataUserAlert from './MasterDataUserAlert';

class MasterDataUserFirstPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showWarningAlertLead: false,
            showWarningAlertLevel: false,
            showWarningAlertSpecialization: false,
            showWarningAlertDistributorId: false,
            showWarningAlertFirstName: false,
            showWarningAlertGender: false,
            showWarningAlertIdCard: false,
            showWarningAlertFirstName1: false,
            showWarningAlertLastName: false,
        }
    }

    componentDidMount() {
        document.addEventListener("wheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
    }

    componentWillUnmount() {
        document.removeEventListener("wheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });
    }

    handleChangePage = async page => {
        await this.setState({
            showWarningAlertLead: false,
            showWarningAlertLevel: false,
            showWarningAlertSpecialization: false,
            showWarningAlertDistributorId: false,
            showWarningAlertFirstName: false,
            showWarningAlertGender: false,
        })

        if (this.props.action === 'detail') {
            return this.props.handleChangePage(page)
        }

        if (this.props.assignable) {
            if (this.props.lead.value === '') {
                return this.setState({ showWarningAlertLead: true })
            }

            if (this.props.level.value === '') {
                return this.setState({ showWarningAlertLevel: true })
            }

            if (this.props.specialization.value.length === 0) {
                return this.setState({ showWarningAlertSpecialization: true })
            }
        }

        if (this.props.userCategory.value.value === 'distributor') {
            if (this.props.distributor.value.length === 0) {
                return this.setState({ showWarningAlertDistributorId: true })
            }
        }

        if (this.props.firstName === '') {
            return this.setState({ showWarningAlertFirstName: true, showWarningAlertFirstName1: false })
        }

        if (this.props.gender.value === '') {
            return this.setState({ showWarningAlertGender: true })
        }

        this.props.handleChangePage(page)
    }

    handleChangeLead = async e => {
        await this.props.handleChangeLead(e)
        this.setState({ showWarningAlertLead: false })
    }

    handleChangeLevel = async e => {
        await this.props.handleChangeLevel(e)
        this.setState({ showWarningAlertLevel: false })
    }

    handleChangeSpecialization = async e => {
        await this.props.handleChangeSpecialization(e)
        this.setState({ showWarningAlertSpecialization: false })
    }

    handleChangeDistributor = async e => {
        await this.props.handleChangeDistributor(e)
        this.setState({ showWarningAlertDistributorId: false })
    }

    handleChangeIdCard = async e => {
        await this.props.handleChange(e)

        const validateIdCard = /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/
        if (!this.props.idCard.match(validateIdCard)) {
            return this.setState({ showWarningAlertIdCard: true })
        }
        return this.setState({ showWarningAlertIdCard: false })
    }

    handleChangeFirstName = async e => {
        await this.props.handleChange(e)
        this.setState({ showWarningAlertFirstName: false })

        const validateFirstName = /^[A-Z][a-z]+$/
        if (!this.props.firstName.match(validateFirstName)) {
            return this.setState({ showWarningAlertFirstName1: true })
        }
        return this.setState({ showWarningAlertFirstName1: false })
    }

    handleChangeLastName = async e => {
        await this.props.handleChange(e)
        if (this.props.lastName === '') {
            return this.setState({ showWarningAlertLastName: false })
        }

        const validateLastName = /^[A-Z][a-z]+(([ ][A-Z][a-z])?[a-z]*)*$/
        if (!this.props.lastName.match(validateLastName)) {
            return this.setState({ showWarningAlertLastName: true })
        }
        return this.setState({ showWarningAlertLastName: false })
    }

    handleChangeGender = async e => {
        await this.props.handleChangeGender(e)
        this.setState({ showWarningAlertGender: false })
    }

    render() {
        return (
            <div className="w-full bg-white rounded-b-2xl px-5 py-10 mb-10 relative">
                <div className="flex pb-10 border-b-2 border-gray mb-10">
                    <div className="w-1/2">
                        <div className="box-1 p-5">
                            <div className={this.props.action === "add" ? "hidden" : "flex"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>ID Pengguna</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tslid"
                                        className="form-control"
                                        placeholder="Tulis ID"
                                        name="id"
                                        value={this.props.id}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail" || this.props.action === "edit"}
                                    />
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Kategori Pengguna</div>
                                <div className="w-5/6 flex items-center">
                                    <div className={(this.props.userCategory.value.value === "nexsoft" || this.props.userCategory.value.value === "cso") ? "w-4/6 mr-2" : "w-full"}>
                                        <Select
                                            id="ddsusercategory"
                                            placeholder="Pilih Kategori Pengguna"
                                            value={this.props.userCategory.value}
                                            options={this.props.userCategory.data}
                                            onChange={this.props.handleChangeUserCategory}
                                            isDisabled={this.props.action === "detail" || this.props.action === "add" || this.props.action === "edit"}
                                        />
                                    </div>
                                    {
                                        (this.props.userCategory.value.value === "nexsoft" || this.props.userCategory.value.value === "cso") &&
                                        <div className="w-2/6 flex items-center">
                                            <input
                                                id="ckbassignable"
                                                type="checkbox"
                                                name="assignable"
                                                checked={this.props.assignable}
                                                onChange={this.props.handleChangeAssignable}
                                                disabled={this.props.action === "detail" || (this.props.userCategory.value.value !== 'nexsoft' && this.props.userCategory.value.value !== 'cso')}
                                            />
                                            <label htmlFor="ckbassignable" className="ml-2">CS Officer</label>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Email</div>
                                <div className="w-5/6 relative">
                                    <input
                                        type="email"
                                        id="tslemail"
                                        className="form-control"
                                        placeholder="Tulis Email"
                                        name="email"
                                        value={this.props.email}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail" || this.props.action === "add" || this.props.action === "edit"}
                                    />
                                    {
                                        ((this.props.action === 'detail' || this.props.action === 'edit') && this.props.emailVerified) &&
                                        <div className="flex items-center italic text-sm text-gray-500 absolute top-1/2 right-3 transform -translate-y-1/2"><IconStatusCheckDisabled /> Terverifikasi</div>
                                    }
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Bahasa</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tsllanguage"
                                        className="form-control"
                                        placeholder="Tulis Bahasa"
                                        name="language"
                                        value={this.props.language.placeholder}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        readOnly={this.props.action === "add" || this.props.action === "edit"}
                                        disabled={this.props.action === "detail"}
                                    />
                                </div>
                            </div>

                            <div className={this.props.userCategory.value.value === "nexsoft" || this.props.userCategory.value.value === "cso" ? "flex mt-4" : "hidden"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Atasan </p>
                                    {this.props.action !== 'detail' && this.props.assignable && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <div className="flex items-center">
                                        <div className="w-4/6 mr-2">
                                            <Select
                                                id="ddslead"
                                                placeholder="Pilih Atasan"
                                                value={this.props.lead.value}
                                                options={this.props.lead.data}
                                                onChange={this.handleChangeLead}
                                                isDisabled={this.props.action === "detail"}
                                                isClearable
                                            />
                                        </div>
                                        <div className="w-2/6 flex items-center">
                                            <input
                                                id="ckbislead"
                                                type="checkbox"
                                                name="isLead"
                                                checked={this.props.isLead}
                                                onChange={this.props.handleChangeIsLead}
                                                disabled={this.props.action === "detail" || (this.props.userCategory.value.value !== 'nexsoft' && this.props.userCategory.value.value !== 'cso')}
                                            />
                                            <label htmlFor="ckbislead" className="ml-2">Status Atasan</label>
                                        </div>
                                    </div>
                                    {this.state.showWarningAlertLead && this.props.action !== 'detail' && <MasterDataUserAlert text="Atasan tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>

                        <div className={this.props.userCategory.value.value === "nexsoft" || this.props.userCategory.value.value === "cso" ? "box-2 border border-gray-300 rounded-lg px-5 py-8 relative" : "hidden"}>
                            <div className="absolute -top-3 left-12 bg-white text-lg text-gray-500 font-medium px-3">Officer</div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Level CS </p>
                                    {this.props.action !== 'detail' && this.props.assignable && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="ddslevel"
                                        placeholder="Pilih Level CS"
                                        value={this.props.level.value}
                                        options={this.props.level.data}
                                        onChange={this.handleChangeLevel}
                                        isDisabled={this.props.action === "detail"}
                                        isClearable
                                    />
                                    {this.state.showWarningAlertLevel && this.props.action !== 'detail' && <MasterDataUserAlert text="Level CS tidak boleh kosong!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Spesialisasi </p>
                                    {this.props.action !== 'detail' && this.props.assignable && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlspecialization"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        placeholder="Pilih Spesialisasi"
                                        value={this.props.specialization.value}
                                        options={this.props.specialization.data}
                                        onChange={this.handleChangeSpecialization}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertSpecialization && this.props.action !== 'detail' && <MasterDataUserAlert text="Spesialisasi tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>

                        <div className={this.props.userCategory.value.value === "distributor" ? "box-2 border border-gray-300 rounded-lg px-5 py-8 relative" : "hidden"}>
                            <div className="absolute -top-3 left-12 bg-white text-lg text-gray-500 font-medium px-3">Distributor</div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Nama Distributor </p>
                                    {this.props.action !== 'detail' && this.props.userCategory.value.value === 'distributor' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="mlsdistributor"
                                        isMulti
                                        closeMenuOnSelect={false}
                                        placeholder="Pilih Distributor"
                                        value={this.props.distributor.value}
                                        options={this.props.distributor.data}
                                        onChange={this.handleChangeDistributor}
                                        onInputChange={this.props.handleSearchDistributor}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertDistributorId && this.props.action !== 'detail' && <MasterDataUserAlert text="Distributor tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="w-1/2 px-5">
                        <div className="box-3 border border-gray-300 rounded-lg px-5 py-8 relative h-full">
                            <div className="absolute -top-3 left-12 bg-white text-lg text-gray-500 font-medium px-3">Profil Pengguna</div>

                            <div className="flex">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>NIK</div>
                                <div className="w-5/6">
                                    <input
                                        type="number"
                                        id="tslnik"
                                        className="form-control"
                                        placeholder="NIK"
                                        name="idCard"
                                        value={this.props.idCard}
                                        onChange={this.handleChangeIdCard}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertIdCard && this.props.action !== 'detail' && <MasterDataUserAlert text="NIK tidak valid, silahkan cek kembali!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Titel</div>
                                <div className="w-5/6">
                                    <Select
                                        id="ddstitle"
                                        placeholder="Pilih Title"
                                        value={this.props.title.value}
                                        options={this.props.title.data}
                                        onChange={this.props.handleChangeTitle}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Nama Depan </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tslfirstname"
                                        className="form-control"
                                        placeholder="Nama Depan"
                                        name="firstName"
                                        value={this.props.firstName}
                                        onChange={this.handleChangeFirstName}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertFirstName && this.props.action !== 'detail' && <MasterDataUserAlert text="Nama Depan tidak boleh kosong!" />}
                                    {this.state.showWarningAlertFirstName1 && this.props.action !== 'detail' && <MasterDataUserAlert text="Nama Depan hanya karakter huruf dan diawali dengan huruf besar!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Nama Belakang</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tsllastname"
                                        className="form-control"
                                        placeholder="Nama Belakang"
                                        name="lastName"
                                        value={this.props.lastName}
                                        onChange={this.handleChangeLastName}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertLastName && this.props.action !== 'detail' && <MasterDataUserAlert text="Nama Belakang hanya karakter huruf dan diawali dengan huruf besar!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5 flex justify-end"}>
                                    <p className="mr-1">Jenis Kelamin </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <Select
                                        id="ddsgender"
                                        placeholder="Pilih Jenis Kelamin"
                                        value={this.props.gender.value}
                                        options={this.props.gender.data}
                                        onChange={this.handleChangeGender}
                                        isDisabled={this.props.action === "detail"}
                                    />
                                    {this.state.showWarningAlertGender && this.props.action !== 'detail' && <MasterDataUserAlert text="Jenis Kelamin tidak boleh kosong!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Nomor Telepon</div>
                                <div className="w-5/6 flex items-end relative">
                                    <div className="w-1/6 mr-2">
                                        <input
                                            type="text"
                                            id="tslcountrycode"
                                            className="form-control"
                                            placeholder="+62"
                                            name="countryCode"
                                            value={this.props.countryCode}
                                            onChange={this.props.handleChange}
                                            autoComplete="off"
                                            readOnly={this.props.action === "add" || this.props.action === "edit"}
                                            disabled={this.props.action === "detail" || this.props.action === "add" || this.props.action === "edit"}
                                        />
                                    </div>
                                    <div className="w-5/6">
                                        <input
                                            type="number"
                                            id="tslphonenumber"
                                            className="form-control"
                                            placeholder="Tulis Nomor Telepon"
                                            name="phoneNumber"
                                            value={this.props.phoneNumber}
                                            onChange={this.props.handleChange}
                                            autoComplete="off"
                                            disabled={this.props.action === "detail" || this.props.action === "add" || this.props.action === "edit"}
                                        />
                                    </div>
                                    {
                                        ((this.props.action === 'detail' || this.props.action === 'edit') && this.props.phoneVerified) &&
                                        <div className="flex items-center italic text-sm text-gray-500 absolute top-1/2 right-3 transform -translate-y-1/2"><IconStatusCheckDisabled /> Terverifikasi</div>
                                    }
                                </div>
                            </div>

                            <div className={this.props.action === "add" ? "hidden" : "flex mt-4"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Dibuat</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tslcreatedat"
                                        className="form-control"
                                        placeholder="Dibuat"
                                        name="createdAt"
                                        value={this.props.createdAt}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail" || this.props.action === "edit"}
                                    />
                                </div>
                            </div>

                            <div className={this.props.action === "add" ? "hidden" : "flex mt-4"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Diubah</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tslupdatedat"
                                        className="form-control"
                                        placeholder="Diubah"
                                        name="updatedAt"
                                        value={this.props.updatedAt}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail" || this.props.action === "edit"}
                                    />
                                </div>
                            </div>

                            <div className={this.props.action === "add" ? "hidden" : "flex mt-4"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Diubah Oleh</div>
                                <div className="w-5/6">
                                    <input
                                        type="text"
                                        id="tslupdatedby"
                                        className="form-control"
                                        placeholder="Diubah Oleh"
                                        name="updatedBy"
                                        value={this.props.updatedBy}
                                        onChange={this.props.handleChange}
                                        autoComplete="off"
                                        disabled={this.props.action === "detail" || this.props.action === "edit"}
                                    />
                                </div>
                            </div>

                            <div className={this.props.action === "add" ? "hidden" : "flex mt-4"}>
                                <div className={this.props.action === "detail" ? "w-1/6 text-right text-gray-500 font-bold mr-5" : "w-1/6 text-right font-bold mr-5"}>Status</div>
                                <div className="w-5/6">
                                    <RadioTab id="tglstatus" radioInputName="status" dataOption={MENU_USER.dataStatus} defaultCheck={JSON.stringify(this.props.status)} onChange={this.props.handleChangeStatus} disabled={this.props.action === "detail"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="absolute bottom-5 right-5">
                    <button type="button" id="btnback" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none w-32 py-2 mt-3 mr-2" onClick={() => this.props.history.goBack()}>Kembali</button>
                    <button type="submit" id="btnnext" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none w-32 py-2 mt-3 ml-2" onClick={() => this.handleChangePage(2)}>Selanjutnya</button>
                </div>
            </div>
        );
    }
}

export default withRouter(MasterDataUserFirstPage);